import classNames from "classnames";
import s from './Sessions.module.scss';
import block from "bem-css-modules";
import {Session} from "./Session";

const b = block(s);
export const Sessions = ({sessions}) => {
    let time = '';
    return (<>
        {sessions.map((session, index) => {
            let timeString = null;
            const timeLocal = `${session.time_from} - ${session.time_till}`;
            if (time !== timeLocal) {
                time = timeLocal;
                timeString = timeLocal;
                if (session.time_from === session.time_till){
                    timeString = session.time_from;
                }
            }
            return (<div key={index} className={classNames('row', b('timeslot'))}>
                <div className={classNames('col-3', b('time', {empty: timeString === null}))}>{timeString}</div>
                <Session index={index} session={session} noBorder={timeString === null}/>
            </div>)
        })}
    </>)
}
